import React from 'react'
import styled from 'styled-components'
import { Typography, Input } from 'antd'
import { FormattedMessage } from 'react-intl'
import { Edit } from 'react-feather'

import { FlexRow } from '../FlexboxReusables/FlexItems'
import { Course } from './types'

type CourseNameProps = {
  course: Course
  setCourse: (value: React.SetStateAction<Course | null>) => void
  setEditing: (value: React.SetStateAction<Record<string, boolean>>) => void
  editing: Record<string, boolean>
}

const CourseName: React.FC<CourseNameProps> = ({ ...props }) => {
  const { course, setCourse, setEditing, editing } = props

  return (
    <FlexRow height='3em' justifyContent='flex-start' padding='10px'>
      {editing.name && course
        ? <Input
          height={30}
          value={course.name}
          onChange={(e) => setCourse((prevCourse) => ({
            ...prevCourse,
            name: e.target.value,
            hasUnsavedChanges: true
          }) as Course)}
          onBlur={() => setEditing({ ...editing, name: false })}
        />
        : <>
          <Typography.Title level={3} style={{ paddingTop: '3px' }}>
            {course.name || <FormattedMessage id='course.newCourse' />}
          </Typography.Title>
          <EditIconWrapper>
            <Edit size={16} onClick={() => setEditing({ ...editing, name: true })} />
          </EditIconWrapper>
        </>
      }
    </FlexRow>
  )
}

export default CourseName

export const EditIconWrapper = styled.div`
  margin-left: 0.5em;
  padding-bottom: 0.3em;
  cursor: pointer;
`